import { Component, ElementRef, OnInit } from "@angular/core";
import { AuthService } from "../../auth/auth.service";
import { permissions } from "../../permissions";
import { Router } from "@angular/router";
import { SidebarService } from "../../services/sidebar.service";

@Component({
  selector: "app-settings-menu",
  templateUrl: "./settings-menu.component.html",
  styleUrls: ["./settings-menu.component.scss"],
  // tslint:disable-next-line:use-host-property-decorator
  host: {
    "(document:click)": "handleClick($event)",
  },
})
export class SettingsMenuComponent implements OnInit {
  show = false;
  public elementRef;
  public permissions = permissions;
  public username = "Menu";

  constructor(
    private authService: AuthService,
    private myElement: ElementRef,
    private router: Router,
    private sidebarService: SidebarService
  ) {
    this.elementRef = myElement;
  }

  ngOnInit() {
    let username = this.authService.username;
    if (username != null && username.trim().length > 0) {
      this.username = this.authService.username;
    }
    if (this.username === "Menu") {
      // if not loaded immediately, try after a small delay
      setTimeout(() => {
        username = this.authService.username;
        if (username != null && username.trim().length > 0) {
          this.username = this.authService.username;
        }
      }, 1500);
    }
  }

  changePassword() {
    this.router.navigate(["user/change-password/" + this.authService.userId]);
  }

  logout() {
    this.authService.logout();
  }

  handleClick(event) {
    let clickedComponent = event.target;
    let inside = false;
    do {
      if (clickedComponent === this.elementRef.nativeElement) {
        inside = true;
      }
      clickedComponent = clickedComponent.parentNode;
    } while (clickedComponent);
    if (inside) {
      this.show = !this.show;
    } else {
      this.show = false;
    }
  }

  displayWhatsNew() {
    this.sidebarService.toggleWhatsNew();
  }
}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/components/settings-menu/settings-menu.component.ts